import React, { useEffect, useState } from "react";
import Header from "./../../components/header/Header";
import Footer from "./../../components/footer/Footer";
import Categories from "../../components/categories/Categories";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";

import "./Product.css";
import { Link, useParams } from "react-router-dom";
import Loader from "../../components/loader/Loader";
import { Helmet } from "react-helmet";

export default function Product() {
  const { cat_id } = useParams();
  const [products, setProducts] = useState([]);
  const [countProduct, setCountProduct] = useState(0);

  const [isLoader, setIsLoader] = useState(true);

  useEffect(() => {
    fetch("https://meta-detector.com/v1/api/products")
      .then((res) => res.json())
      .then((resutl) => {
        setProducts(resutl.data);
        setCountProduct(0);
        resutl.data.forEach((product) => {
          if (product.group_id === Number(cat_id)) {
            setCountProduct((prevCount) => prevCount + 1);
          }
        });

        setIsLoader(false);
      });
  }, [cat_id]);

  if (isLoader) {
    return <Loader loaderStyle={isLoader ? "flex" : "none"} />;
  }

  return (
    <>
      <Helmet>
        <title>{`Meta Detector | Categories`}</title>
      </Helmet>
      <Header />
      <main id="content" className={"product-wrapper"}>
        <input type="hidden" name="nbProduits" id="nbProduits" value="1" />
        <input type="hidden" name="nextPage" id="nextPage" value="2" />
        <input
          type="hidden"
          name="from_documentation"
          id="from_documentation"
          value=""
        />

        <Breadcrumb links={[{ id: 1, title: "Accessories" }]} />

        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-4 col-xl-4">
              <Categories catID={cat_id} />
            </div>
            <div className="col-12 col-lg-8 col-xl-8" id="liste-wrapper">
              <div className="wrapper-controls">
                <div className="row">
                  <div className="col-6 col-md-4">
                    <p className="results">{countProduct} Result </p>
                  </div>
                </div>
              </div>

              <div className="row row-gap-2 liste" id="listProduct">
                {products.map((product) => (
                  <>
                    {product.group_id == Number(cat_id) ? (
                      <div
                        key={product.id}
                        className={`${"col-12"} item wrapper-product`}
                      >
                        <div
                          className={`encart-product wrapperClic ${"encart-product-list"}`}
                        >
                          <Link to={`/product/${product.title}`} target="_self">
                            <div className="container-img">
                              <img
                                src={`${window.location.origin}${product.image.url}`}
                                alt={product.title}
                                className="img-fluid"
                                style={{ display: "inline" }}
                              />
                            </div>
                          </Link>
                          <div className="container-caption">
                            <div className="caption">
                              <div className="row">
                                <div className="col-12">
                                  <p className="title">
                                    <Link
                                      to={`/product/${product.title}`}
                                      target="_self"
                                    >
                                      {product.title}
                                    </Link>
                                  </p>
                                  <div
                                    className="desc"
                                    dangerouslySetInnerHTML={{
                                      __html: product.description.slice(0, 40),
                                    }}
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                ))}
                <div
                  id="show-more"
                  className="show-more"
                  arial-label="Voir plus d'accessoires"
                  style={{ display: "none" }}
                >
                  <div className="loader-cycle-disks"></div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
